import { alertConstants } from "../constants";

export function alert(state = {}, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case alertConstants.SUCCESS:
      currentstate = { variant: "success", message: action.message };
      break;
    case alertConstants.ERROR:
      currentstate = { variant: "error", message: action.message };
      break;
    case alertConstants.WARN:
      currentstate = { variant: "warning", message: action.message };
      break;
    case alertConstants.INFO:
      currentstate = { variant: "info", message: action.message };
      break;
    case alertConstants.CLEAR:
      currentstate = { variant: null, message: null };
      break;
    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
